<template>
  <modal
    :title="setModel != undefined ? 'Update Squid' : 'Add Squid'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="customers == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        v-if="customers != null"
        class="floating-labels p-1rem row"
        ref="form"
      >
        <div class="col-12">
          <formGroup
            :title="'Platform'"
            v-model="model.Platform"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-9">
          <formGroup
            :title="'IP'"
            v-model="model.IP"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-3">
          <formGroup
            :title="'Port'"
            type="number"
            v-model.number="model.Port"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Username'"
            v-model="model.Username"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Password'"
            v-model="model.Password"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-12">
          <formGroup
            :title="'CustomerId'"
            :as="'select'"
            :disabled="customers.length == 0"
            v-model="model.CustomerId"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #input>
              <option :value="null"></option>
              <option
                v-for="item in customers"
                :value="item.Id"
                :key="item.Id"
                >{{ item.Name }}</option
              >
            </template>
          </formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Confirm'"
            :as="'checkbox'"
            v-model="model.Confirm"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Pdf'"
            :as="'checkbox'"
            v-model="model.Pdf"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Active'"
            :as="'checkbox'"
            v-model="model.Active"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="customers == null"
        :process="process"
        >{{ setModel != undefined ? "Update Squid" : "Add Squid" }}</Btn
      >
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    operators: Array,
  },
  data() {
    return {
      model: {
        Id: null,
        Platform: null,
        IP: null,
        Port: null,
        Username: null,
        Password: null,
        Confirm: true,
        Pdf: true,
        Active: true,
        CustomerId: null,
      },
      process: false,
      customers: null,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
    this.$appAxiosAdmin.get(`CustomersNames`).then((response) => {
      this.customers = this.$orderByArray(response.data, "Name", false, false);
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`Squids`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The squid has been successfully updated."
                    : "The squid has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
